import { useState, useRef, useEffect } from "react";
import { useLanguage } from "../context/LanguageContext";

/**
 * LangDropdown — ปุ่มลูกโลก 🌐 กดแล้วเปิด dropdown เลือกภาษา
 * ใช้ร่วมกันทุก navbar (user / staff / admin) โทนสว่างตามแอป
 */
const LANGS = [
  { code: "th", label: "TH - ภาษาไทย" },
  { code: "en", label: "EN - English" },
];

function LangDropdown() {
  const { lang, setLanguage } = useLanguage();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  // ปิดเมื่อคลิกนอก (pattern เดียวกับ dropdown ใน NavbarStaff)
  useEffect(() => {
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div ref={wrapRef} style={{ position: "relative" }}>
      <button
        onClick={() => setOpen((p) => !p)}
        aria-label="Change language"
        title={lang === "th" ? "ภาษา" : "Language"}
        style={{
          background: "none", border: "none", cursor: "pointer",
          display: "flex", alignItems: "center", justifyContent: "center",
          padding: 6, borderRadius: 8, color: "#374151",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.background = "#f3f4f6")}
        onMouseLeave={(e) => (e.currentTarget.style.background = "none")}
      >
        <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="2" y1="12" x2="22" y2="12" />
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
        </svg>
      </button>

      {open && (
        <div style={{
          position: "absolute", top: "calc(100% + 8px)", right: 0,
          background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12,
          boxShadow: "0 8px 24px rgba(0,0,0,.10)", minWidth: 160,
          padding: 4, zIndex: 1200,
        }}>
          {LANGS.map(({ code, label }) => {
            const active = lang === code;
            return (
              <button
                key={code}
                onClick={() => { setLanguage(code); setOpen(false); }}
                style={{
                  display: "block", width: "100%", textAlign: "left",
                  padding: "9px 12px", borderRadius: 8, border: "none",
                  cursor: "pointer", fontSize: 13, whiteSpace: "nowrap",
                  fontFamily: "'Noto Sans Thai',sans-serif",
                  background: active ? "#f3f4f6" : "none",
                  color: active ? "#111827" : "#4b5563",
                  fontWeight: active ? 700 : 500,
                }}
                onMouseEnter={(e) => { if (!active) e.currentTarget.style.background = "#f9fafb"; }}
                onMouseLeave={(e) => { if (!active) e.currentTarget.style.background = "none"; }}
              >
                {label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default LangDropdown;
